import { render } from "./OfferRewardsList.vue?vue&type=template&id=13d20d6c"
import script from "./OfferRewardsList.vue?vue&type=script&lang=js"
export * from "./OfferRewardsList.vue?vue&type=script&lang=js"

import "./OfferRewardsList.vue?vue&type=style&index=0&id=13d20d6c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__